import React from 'react';
import moment from 'moment';
import { formatDateAndTime } from '../../../function/Helper';

interface IProps {
  selectedCallbackInfo: any;
}

const SpecificComplaintDetails = (props: IProps) => {
  const { selectedCallbackInfo } = props;

  return (
    <div className="xl:h-[calc(100vh-264px)] flex flex-col gap-3 p-2 xl:p-4 overflow-y-auto">
      <div className="flex gap-5">
        <label className="text-sm text-white font-bold">Raised on</label>
        <label className="text-sm text-white font-normal">
          {selectedCallbackInfo.createdAt
            ? // ? moment(selectedCallbackInfo.createdAt).local().format('L')
              formatDateAndTime(selectedCallbackInfo.createdAt)
            : '-'}
        </label>
      </div>

      <div className="flex gap-12">
        <label className="text-sm text-white font-bold">Name</label>
        <label className="text-sm text-white font-normal break-all">
          {selectedCallbackInfo.name || '-'}
        </label>
      </div>

      <div className="flex gap-[52px]">
        <label className="text-sm text-white font-bold">Email</label>
        <label className="text-sm text-white font-normal">
          {selectedCallbackInfo.email || '-'}
        </label>
      </div>

      <div className="flex gap-3.5">
        <label className="text-sm text-white font-bold">Description</label>
        <label className="text-sm text-white font-normal break-all">
          {selectedCallbackInfo.description || '-'}
        </label>
      </div>
    </div>
  );
};

export default SpecificComplaintDetails;
